/**
 * Farm & Acre Co - Allflex tag photos in the picked colour (Brooke's retest, 23 Oct 2026).
 *
 * Cart drawer and cart page thumbnails carry data-allflex-colour (the line's Color property). When the
 * thumbnail is one of our orange photos (allflex-pair-* set pages, allflex-colour-* blank packs, built by
 * scripts/allflex-transition/pair-images/build.py) it is recoloured in the browser with the same maths as
 * the product page (allflex-marking-picker.js recolourPixels). Blank pack product pages are recoloured here
 * too (bootPage); set pages use the picker. Photo only: the order is untouched. Checkout and order emails
 * are Shopify's own pages and keep the orange photo. Any failure leaves the orange.
 */
(function () {
  'use strict';
  if (window.__allflexPairColour) return; // loaded by the cart drawer and by the blank pack form: run once
  window.__allflexPairColour = true;

  // Same hex values as the colour swatches in snippets/form-visual-tag.liquid. Orange is the photo as built.
  var HEX = {
    'black': '#1A1A1A', 'blue': '#0099D9', 'blue-light': '#4EC1E0', 'blue-dark': '#1057A8', 'brown': '#8B4513',
    'green': '#3FAE49', 'green-light': '#A5D63F', 'green-neon': '#76B843', 'green-dark': '#1E6F2E', 'grey': '#7A7A7A',
    'gray': '#7A7A7A', 'orange-light': '#FF9233', 'orange-dark': '#D84A00', 'pink': '#E94B7F', 'pink-light': '#F498B6',
    'pink-dark': '#B71F58', 'purple': '#7E2C8A', 'purple-light': '#B580C9', 'purple-dark': '#55287A', 'red': '#E32227',
    'red-light': '#F25D63', 'white': '#FFFFFF', 'yellow': '#FFE100'
  };
  var PAIR_BASE_HUE = 0.075;
  var cache = {};

  function rgbToHsv(r, g, b) {
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn, h = 0;
    if (d > 0) {
      if (mx === r) h = ((g - b) / d) % 6;
      else if (mx === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h /= 6;
      if (h < 0) h += 1;
    }
    return [h, mx > 0 ? d / mx : 0, mx / 255];
  }

  function hsvToRgb(h, s, v) {
    var i = Math.floor(h * 6) % 6, f = h * 6 - Math.floor(h * 6);
    var p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s);
    var c = [[v, t, p], [q, v, p], [p, v, t], [p, q, v], [t, p, v], [v, p, q]][i];
    return [c[0] * 255, c[1] * 255, c[2] * 255];
  }

  function recolourPixels(data, hex) {
    var m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex);
    var t = rgbToHsv(parseInt(m[1], 16), parseInt(m[2], 16), parseInt(m[3], 16));
    for (var i = 0; i < data.length; i += 4) {
      var px = rgbToHsv(data[i], data[i + 1], data[i + 2]);
      var cover = Math.abs(px[0] - PAIR_BASE_HUE) < 0.06 ? Math.min(Math.max((px[1] - 0.25) / 0.7, 0), 1) : 0;
      if (!cover) continue;
      var n = hsvToRgb(t[0], t[1], Math.min(px[2] * t[2], 1));
      for (var k = 0; k < 3; k++) data[i + k] = Math.round(cover * n[k] + (1 - cover) * data[i + k]);
    }
  }

  function slug(s) {
    return String(s || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  var PHOTO_RE = /allflex-(pair|colour)-/; // pair photos (set pages) and single-tag photos (blank packs)

  /** The orange photo at src, recoloured to hex, as a data URL (cached). */
  function recolourUrl(src, hex) {
    var key = src + '|' + hex;
    if (cache[key]) return Promise.resolve(cache[key]);
    return new Promise(function (resolve, reject) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var c = document.createElement('canvas');
          c.width = im.naturalWidth;
          c.height = im.naturalHeight;
          var ctx = c.getContext('2d');
          ctx.drawImage(im, 0, 0);
          var d = ctx.getImageData(0, 0, c.width, c.height);
          recolourPixels(d.data, hex);
          ctx.putImageData(d, 0, 0);
          resolve(cache[key] = c.toDataURL('image/jpeg', 0.9));
        } catch (e) { reject(e); }
      };
      im.onerror = reject;
      im.src = src + (src.indexOf('?') < 0 ? '?' : '&') + 'mb-colour=1';
    });
  }

  function recolour(img) {
    if (img.__allflexPair) return;
    img.__allflexPair = true;
    var src = img.getAttribute('src') || '';
    var hex = HEX[slug(img.getAttribute('data-allflex-colour'))];
    if (!PHOTO_RE.test(src) || !hex) return; // not one of our photos, Orange, or an unknown colour
    recolourUrl(src, hex).then(function (url) { img.removeAttribute('srcset'); img.src = url; }, function () { /* stays orange */ });
  }

  /**
   * Blank pack product pages (Aaron, 23 Oct): the first photo is the pack's tag in Orange (allflex-colour-*).
   * Picking a colour swatch recolours it; the colour ticked when the page opens is applied straight away.
   * Set pages (allflex-pair-*) are handled by allflex-marking-picker.js, so they are left alone here.
   */
  function bootPage() {
    // Every gallery slide showing one of our orange single-tag photos (blank pack: one; Custom Designed Tags: one per size).
    var photos = [];
    Array.prototype.forEach.call(document.querySelectorAll('.product-slider__slide'), function (slide) {
      var img = slide.querySelector('img');
      if (!img || !/allflex-colour-/.test(img.getAttribute('src') || '')) return;
      var thumb = document.querySelector('.product-slider__thumbnail[data-thumbnail-index="' + slide.getAttribute('data-slide-index') + '"] img');
      photos.push({ img: img, thumb: thumb, src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), alt: img.getAttribute('alt') || '', thumbSrc: thumb ? thumb.getAttribute('src') : null });
    });
    if (!photos.length) return;
    var show = function (radio) {
      var name = radio.value;
      var hex = HEX[slug(name)];
      photos.forEach(function (p) {
        if (!hex) { // Orange (the photo as built) or an unknown colour
          p.img.setAttribute('src', p.src);
          if (p.srcset) p.img.setAttribute('srcset', p.srcset);
          p.img.setAttribute('alt', p.alt);
          if (p.thumb && p.thumbSrc) p.thumb.setAttribute('src', p.thumbSrc);
          return;
        }
        recolourUrl(p.src, hex).then(function (url) {
          p.img.removeAttribute('srcset');
          p.img.setAttribute('src', url);
          p.img.setAttribute('alt', p.alt + ', shown in ' + name);
          if (p.thumb) p.thumb.setAttribute('src', url);
        }, function () { /* stays orange */ });
      });
    };
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name === 'properties[Color]' && t.checked) show(t);
    });
    var ticked = document.querySelector('input[name="properties[Color]"]:checked');
    if (ticked) show(ticked);
  }

  /** Custom Designed Tags: picking a Tag size shows that size's photo (its variant image, data-media-id on the card). */
  function bootSizePhotos() {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.checked || !/^cd-tag-size-/.test(t.name || '') || !t.getAttribute('data-media-id')) return;
      var slide = document.querySelector('.product-slider__slide[data-media-id="' + t.getAttribute('data-media-id') + '"]');
      if (!slide) return;
      var btn = document.querySelector('.product-slider__thumbnail[data-thumbnail-index="' + slide.getAttribute('data-slide-index') + '"]');
      if (btn) btn.click();
    });
  }

  function scan(root) {
    var list = root.querySelectorAll ? root.querySelectorAll('img[data-allflex-colour]') : [];
    for (var i = 0; i < list.length; i++) recolour(list[i]);
    if (root.matches && root.matches('img[data-allflex-colour]')) recolour(root);
  }

  function start() {
    try { bootPage(); } catch (e) { /* photo stays orange */ }
    try { bootSizePhotos(); } catch (e) { /* gallery stays where it is */ }
    scan(document);
    // The cart drawer re-renders its items after every add / change: recolour the new thumbnails too.
    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        records.forEach(function (r) { Array.prototype.forEach.call(r.addedNodes, function (n) { if (n.nodeType === 1) scan(n); }); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
